import { deepmerge } from "@mui/utils";
import { default as Tooltip } from "./tooltip.js";
const getSliderTokens = (tokens) => {
    return {
        slider: tokens.component.slider,
        shadow: tokens.semantic.shadow,
    };
};
const sizeMixin = ({ ownerState, tokens, }) => {
    const { slider } = getSliderTokens(tokens);
    return Object.assign({}, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "medium" && {
        height: slider.track.height.value,
        "& .MuiSlider-rail": {
            height: slider.track.height.value,
        },
        "& .MuiSlider-track": {
            height: slider.track.height.value,
        },
        "& .MuiSlider-thumb": {
            width: slider.thumb.width.value,
            height: slider.thumb.height.value,
        },
    }));
};
const colorMixin = ({ ownerState, tokens, }) => {
    const { slider } = getSliderTokens(tokens);
    return Object.assign({}, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "primary" && {
        color: slider.thumb.backgroundColor.value,
        "&:hover .MuiSlider-thumb": {
            backgroundColor: slider.hover.thumb.backgroundColor.value,
        },
        "& .MuiSlider-thumb.Mui-active": {
            backgroundColor: slider.active.thumb.backgroundColor.value,
        },
        // MUI Rail = Atlas Track
        "& .MuiSlider-rail": {
            backgroundColor: slider.track.backgroundColor.value,
            opacity: 1,
        },
        // MUI Track = Atlas Progress
        "& .MuiSlider-track": {
            border: "none",
            backgroundColor: slider.progress.backgroundColor.value,
        },
        "&:hover .MuiSlider-track": {
            backgroundColor: slider.hover.progress.backgroundColor.value,
        },
    }));
};
const sliderDefaults = ({ tokens }) => {
    var _a, _b, _c;
    const { slider, shadow } = getSliderTokens(tokens);
    return {
        "& .MuiSlider-thumb": {
            // Remove the extra MUI shadow and ripple
            "&:before,&:after": {
                display: "none",
            },
            "&:hover": {
                boxShadow: "none",
            },
            "&.Mui-active,&.Mui-focusVisible": {
                boxShadow: shadow.focus.value.stringValue,
            },
        },
        // Inherit tooltip settings
        "& .MuiSlider-valueLabelOpen": ((_c = (_b = (_a = Tooltip(tokens)) === null || _a === void 0 ? void 0 : _a.MuiTooltip) === null || _b === void 0 ? void 0 : _b.styleOverrides) === null || _c === void 0 ? void 0 : _c.tooltip) || {},
        // Set disabled styles for all colors
        "&.Mui-disabled": {
            "& .MuiSlider-rail": {
                backgroundColor: slider.disabled.track.backgroundColor.value,
            },
            "& .MuiSlider-track": {
                backgroundColor: slider.disabled.progress.backgroundColor.value,
            },
            "& .MuiSlider-thumb": {
                backgroundColor: slider.disabled.thumb.backgroundColor.value,
            },
        },
    };
};
const slider = (tokens) => {
    return {
        MuiSlider: {
            styleOverrides: {
                root: ({ ownerState }) => deepmerge(sliderDefaults({ tokens }), deepmerge(colorMixin({ ownerState, tokens }), sizeMixin({ ownerState, tokens }))),
            },
        },
    };
};
export default slider;
//# sourceMappingURL=slider.js.map